import { render, staticRenderFns } from "./DataTransfersInOutDailyList.vue?vue&type=template&id=e6310a82"
import script from "./DataTransfersInOutDailyList.vue?vue&type=script&lang=js"
export * from "./DataTransfersInOutDailyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports